angular.module('LeasePilot').filter('suppressLeadingZeros', function() {
  return function(input) {
    return _.trimStart(input, '0');
  };
});
